import {
    bootstrapsKeyword,
    getFromLocalStorage,
} from '@/shared/localStorage/localStorageRepository'

export const getBootstraps = () => {
    const bootstrapsObjects = getFromLocalStorage(bootstrapsKeyword)

    if (!bootstrapsObjects) return

    return JSON.parse(bootstrapsObjects)
}
